// extracted by mini-css-extract-plugin
module.exports = {"root":"_f1d762","startingPrice":"_fefca0"};